import { Component, DestroyRef, OnInit } from '@angular/core';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DataType, RuleInterface } from '@vendasta/automata';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { GalaxyTagsModule } from '@vendasta/galaxy/tags';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const PRIMARY_TAG = 'Primary';

@Component({
  selector: 'automata-associate-company-contact-panel',
  templateUrl: './associate-company-contact-panel.component.html',
  styleUrls: ['./associate-company-contact-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    GalaxyTagsModule,
    GalaxyFormFieldModule,
  ],
})
export class AssociateCompanyContactPanelComponent extends CommonActionPanelComponent implements OnInit {
  supportedDataTypes: DataType[] = [DataType.DATA_TYPE_STRING];
  tags: UntypedFormControl = new UntypedFormControl([PRIMARY_TAG], [Validators.required]);

  constructor(private readonly destroyRef: DestroyRef) {
    super();
  }

  ngOnInit(): void {
    this.tags.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((tags: string[]) => {
      // If the user removes the primary tag, add it back because it is required
      if (!tags?.includes(PRIMARY_TAG)) {
        const updatedTags = [PRIMARY_TAG, ...tags];
        this.tags?.setValue(updatedTags, { emitEvent: false });
      }
    });

    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step?.data ? JSON.parse(this.step!.data!) : {};
    jsonData.tags = this.tags.value;

    return jsonData;
  }

  isFormValid(): boolean {
    return this.tags.valid;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.tags];
  }
}
